var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDefaultFilter = function SvgDefaultFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M16.874 16.104v2H2.969v-2zm0-6v2H2.969v-2zm0-6v2H2.969v-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.032 3.104v4H6.094v-4zm5.937 6v4h-2.938v-4zm-3.938 6v4H8.093v-4z"
  }))));
};
export default SvgDefaultFilter;